// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5934":"dd2c2f2027f79f07","7003":"56db3de64d6c3d67","8497":"edf57dce997805c5","9204":"b39dbd97004bc4b5"}[chunkId] + ".css";
};